import { useLocation, useNavigate } from "@tanstack/react-router";
import { useCallback, useEffect } from "react";

import { LICENSES_PAGE, READER_PAGES } from "./readerPages";

const PAGE_PATHS: ReadonlySet<string> = new Set([
  ...READER_PAGES.map((page) => page.to),
  LICENSES_PAGE,
]);

function isPagePath(pathname: string) {
  return PAGE_PATHS.has(pathname.replace(/\/+$/, ""));
}

let mainAppHref: string | null = null;

// Mount once in the app shell. Records the latest main app URL so Back can
// return there no matter how many pages were visited since.
export function MainAppLocationTracker() {
  const href = useLocation({
    select: (location) => (isPagePath(location.pathname) ? null : location.href),
  });
  useEffect(() => {
    if (href !== null) mainAppHref = href;
  }, [href]);
  return null;
}

// Leaves a page for the last main app URL, or the thread list when the app
// was opened directly on a page.
export function useNavigateToMainApp() {
  const navigate = useNavigate();
  return useCallback(() => navigate({ href: mainAppHref ?? "/" }), [navigate]);
}
